<template>
  <div>
    <h1>Editar permisos del rol </h1>
    <a-form :form="form" @submit.prevent="handleSubmit">
      <h1>{{$v.roleName.$model}}</h1>
      <!--
      <a-form-item label="Nombre del rol">
        <a-input
          placeholder="Nombre del rol"
          v-model="$v.roleName.$model"
        />
        <small class="text-danger" v-if="!$v.roleName.required">Campo requerido</small>
      </a-form-item>
      {{selected}}-->
      <!--
      <b-form-checkbox-group
        id="checkbox-group-2"
        v-model="selected"
         @change="selectedObjectUpdate"
        name="flavour-2">
        <b-table
          show-empty
          stacked="md"
          :items="items"
          :current-page="currentPage"
          :per-page="perPage"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          empty-text="No existen registros por mostrar"
        >
        <template v-slot:cell(title)="row">
          <b-form-checkbox :value="row.item.title">{{ row.item.title }}</b-form-checkbox>
        </template>
        </b-table>
      </b-form-checkbox-group> -->
      <b-table
          show-empty
          stacked="md"
          :items="items"
          :current-page="currentPage"
          :per-page="perPage"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          empty-text="No existen registros por mostrar"
          emptyFilteredText="No existen registros por mostrar"
        >
          <template v-slot:cell(acciones)="row">
            <b-button size="sm" @click="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? 'Cerrar' : 'Ver'}} detalles
            </b-button>
          </template>
          <template #row-details="row">
            <b-form-checkbox-group
              id="checkbox-group-2"
              v-model="selected[row.item.title]"
              @change="selectedObjectUpdate"
              name="flavour-2">
              <b-table
                :items="row.item.children"
                small
                borderless
                :fields="[{ key: 'title', label:'Sub módulo' }]"
                >
                <template v-slot:cell(title)="row">
                  <b-form-checkbox :value="row.item.title">{{ row.item.title }}</b-form-checkbox>
                </template>
              </b-table>
            </b-form-checkbox-group>
          </template>
        <!--
        <template v-slot:cell(title)="row">
          <b-form-checkbox :value="row.item.title">{{ row.item.title }}</b-form-checkbox>
        </template>-->
      </b-table>
      <b-row sm="auto"  md="auto">
        <b-button
          variant="success"
          block
          @click="updateRole"
          :disabled="!( $v.roleName.$model )"
          >Actualizar
        </b-button>
      </b-row>
    </a-form>
  </div>
</template>
<script>
import { getMenuData } from '../../../../services/menu/index.js'
import { required /* decimal */ } from 'vuelidate/lib/validators'
import * as firebase from 'firebase/app'
/*
import gql from 'graphql-tag'
const UPDATE_ROLE = gql`
  mutation updateRole($name: String){
    updateRole(role: { name: $name }){
      id
      name
    }
  }
`
*/
export default {
  data() {
    return {
      roleName: this.$route.params.name,
      form: this.$form.createForm(this),
      selected: [],
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      fields: [
        { key: 'title', label: 'Módulo' },
        'acciones',
      ],
    }
  },
  methods: {
    selectedObjectUpdate() {
      // console.log(this.selected)
    },
    updateRole() {
      firebase.firestore().collection('roles').doc(this.$route.params.name).set(this.selected)
        .then(data => {
          this.$router.replace('/')
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
  mounted() {
    console.log(this.$route.params)
    firebase.firestore().collection('roles').doc(this.$route.params.name).get()
      .then(document => {
        this.selected = document.data()
        // console.log(Object.values(document.data()))
        console.log(this.selected, 'rol ' + this.$route.params.name)
      })
      .catch(err => {
        console.log(err)
      })
    getMenuData.forEach(item => {
      if (!item.category) {
        this.items.push(item)
      }
    })
  },
  validations: {
    roleName: { required },
  },
}
</script>
